import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/64c91c6d30c4ecd64eefd4512c25345c.png"
              alt="RBF Express - Transporte Empresarial"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('solucoes')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              Soluções para Empresas
            </button>
            <button
              onClick={() => scrollToSection('regioes')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              Regiões Atendidas
            </button>
            <button
              onClick={() => scrollToSection('frota')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              Frota
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#ff6f00]' : 'text-white hover:text-[#ff6f00]'
              }`}
            >
              FAQ
            </button>
            <a
              href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#ff6f00] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#e66300] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contato
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-white shadow-lg"
        >
          <div className="container mx-auto px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('solucoes')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              Soluções para Empresas
            </button>
            <button
              onClick={() => scrollToSection('regioes')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              Regiões Atendidas
            </button>
            <button
              onClick={() => scrollToSection('frota')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              Frota
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-gray-700 hover:text-[#ff6f00] font-medium py-2 cursor-pointer"
            >
              FAQ
            </button>
            <a
              href="https://wa.me/5512991064271?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20para%20transporte%20de%20pe%C3%A7as%2Finsumos%2Fdocumentos%20para%20minha%20empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center bg-[#ff6f00] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#e66300] transition-all cursor-pointer"
            >
              Contato
            </a>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
